<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Тарифные планы <router-link class="btn btn-primary" :to="{ name: 'rate-plan-add' }">+ Добавить тарифный план</router-link></h1>

    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'settings' }">← Назад к Настройкам</router-link>
    </div>

    <resource-list
      url="/rate-plans"
      current-sort="name"
      resource-name="rate-plans"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'rate-plans',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'name', label: 'Название', sort: true },
        { name: 'amount', label: 'Тариф в месяц', sort: true, money: true }
      ],
      filters: {
        name: ''
      },
      actionRoutes: [
        { name: 'rate-plan-details', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// RatePlans.vue?143b4cec